export const optionsRange = [
    { value: '>=', label: 'Maior ou Igual' },
    { value: '<=', label: 'Menor ou Igual' },
];